import { css } from 'lit';

export const timeredCounterDatetimeStyles = css`
  ::part(part-suffix) {
    font-size: 0.4em;
    line-height: 1;
  }
`;
